import contentData from './content_data.json'

export type QuestionType = 'single' | 'multi'

export interface QuestionOption {
  value: string
  text: string
  category?: string
  fires?: string
  exclusive?: boolean
}

export interface Question {
  id: string
  block: string
  type: QuestionType
  label: string
  options?: QuestionOption[]
  // Q2 は Q1 の選択によって選択肢が変わる
  branchOn?: string
  optionsByBranch?: Record<string, string[]>
  // この条件に合致する場合は設問自体をスキップする
  skipWhen?: (answers: Record<string, string | string[]>) => boolean
  escape?: { value: string; text: string }
}

export const BLOCKS = ['いまの課題', 'いまの体制と実力', '育てたい人', '条件'] as const

// スキップ条件だけはJSONで表現できないため、設問IDごとにここで関数を紐付ける。
// 設問の文言・選択肢はすべて content_data.json を正本とする（Ruby側の管理画面・
// レポートページと共有しているため、文言はこのファイルではなく content_data.json を編集する）。
const SKIP_WHEN: Record<string, Question['skipWhen']> = {
  Q2: (a) => a.Q1 === 'q1_unsure',
  Q8: (a) => a.Q6 === 'q6_notyet',
}

export const QUESTIONS: Question[] = (contentData.questions as Question[]).map((q) => ({
  ...q,
  skipWhen: SKIP_WHEN[q.id],
}))

export function questionById(id: string): Question {
  const q = QUESTIONS.find((question) => question.id === id)
  if (!q) throw new Error(`unknown question: ${id}`)
  return q
}
